module.exports = __webpack_public_path__ + "images/clock_icon.png";